import { takeLatest, put } from 'redux-saga/effects';
import { fetchPostAcqTaskHistory, appNotify, setIsFetchingPostAcqTaskHistory } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getTasksForTaskHistorySaga() {
  yield takeLatest(fetchPostAcqTaskHistory, function* ({ payload }) {
    const { taskId, callback } = payload;
    try {
      yield put(setIsFetchingPostAcqTaskHistory(true));
      const res = yield getWithToken(`/api/postAcquisition/tasks/history?taskId=${taskId}`);
      const response = yield res.json();
      const opps = response.length > 0 ? response : []; // return empty array if no opps found

      if (callback) {
        yield callback(opps);
      }
    } catch (error) {
      console.log('error', error.message);
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setIsFetchingPostAcqTaskHistory(false));
    }
  });
}